export const EventCategories = {
  SINGLE_JOB_MANAGEMENT: 'Single Job Management',
  PROJECT_QUESTION: 'Project Question',
  MESSAGES: 'Messages',
  PAYMENTS: 'Payments',
  HIRE: 'Hire',
  FB_CONNECT: 'FB Connect',
  USER_SIGN_IN: 'User Sign In',
  USER_SIGN_UP: 'User Sign Up',
  EMAIL_VERIFICATION: 'Email Verification',
  RESET_PASSWORD: 'Reset Password',
  MANAGE_JOB: 'Manage Job',
  CONSUMER_APP_UPSELL: 'Consumer App Upsell',
  NEXT_JOB_UPSELL: 'Consumer Next Job Upsell',
  VOUCHER: 'Vouchers',
  DIRECTORY: 'Directory',
  HOMEPAGE: 'Homepage',
  POST_JOB_MODAL: 'Post Job Modal',
  LIST_YOUR_BUSINESS: 'List Your Business',
  LIST_YOUR_BUSINESS_FORM: 'signup-form-v1',
  BUNNINGSONBOARDING: 'Bunnings Onboarding',
  COMMUNITY_FEED: 'Community Feed',
  EXTERNAL_RECOMMENDATIONS: 'External Recommendations',
  ARTICLES: 'Articles',
  CREDIT_USAGE: 'Credit Usage'
};

export const EventActions = {
  ACTIVATE_VOUCHERS: 'Activate vouchers',
  ACTIVATE_SHAREABLE_VOUCHERS: 'Activate shareable vouchers',
  ACTION_BUSINESS: 'Action Business',
  CONTACT_SUPPORT: 'Contact Support',
  CHANGE_JOB_STATUS: 'Change Job Status',
  HOMEPAGE_ARTICLE_TITLE: 'Homepage - Clicked Articles - Title',
  HOMEPAGE_ARTICLE_READ: 'Homepage - Clicked Articles - Read Article',
  HOMEPAGE_ARTICLE_ALL: 'Homepage - Clicked Articles - View All',
  VIEW_JOB_DETAILS: 'View Job Details',
  SELECT_WAITLISTED_BUSINESS: 'Select Waitlisted Business',
  POPUP_DISPLAYED_NEW_DESIGN_AND_HAS_CATEGORIES: 'Popup displayed - new design and has Categories',
  REPORT_CONNECTIONS: 'Report Connections',
  CLICKED_LOGIN_BUTTON: 'Clicked Login Button',
  FACEBOOK_CONNECT: 'Facebook Connect',
  SEND_MESSAGE: 'Send Message',
  SELECT_ATTACHMENT: 'Select Attachment',
  MAKE_A_PAYMENT: 'Make a Payment',
  REQUEST_RECEIPT: 'Request Receipt',
  HIRE_BUSINESS: 'Hire Business',
  SIGN_IN_MANAGE_JOB: 'Sign in to Manage Job Button',
  SIGN_UP_WITHIN_MODAL: 'Sign up within modal',
  SWITCH_TO_SIGN_IN: 'Switch to sign in',
  SWITCH_TO_SIGN_UP: 'Switch to sign up',
  VERIFY_EMAIL: 'Complete Verification',
  SET_PASSWORD: 'Set Password', //new
  SEND_QUICK_REPLY: 'Send Quick Reply',
  COMPLETE_RESET_PASSWORD: 'Complete Reset Password',
  CLICKED_FEEDBACK: 'Clicked Feedback',
  BACK_TO_JOB_LIST: 'Back to Job List',
  UPSELL_APP_EMAIL_VERIFICATION: 'Upsell App - Email Verification',
  PRESS_LETS_DO_IT_START_SCREEN: 'Press Lets Do It - Start Screen',
  PRESS_NEXT_CATEGORIES_SCREEN: 'Press Next - Categories Screen',
  PRESS_NEXT_LOCATION_SCREEN: 'Press Next - Location Screen',
  PRESS_NEXT_STARTBY_SCREEN: 'Press Next - Startby Screen',
  PRESS_NEXT_DESCRIPTION_SCREEN: 'Press Next - Description Screen',
  PRESS_GET_QUOTES_CONTACT_SCREEN: 'Press Get Quotes - Contact Screen',
  PRESS_NEXT: 'Press Next -',
  PRESS_BACK: 'Press Back -',
  PRESS_BACK_CATEGORIES_SCREEN: 'Press Back - Categories Screen',
  PRESS_BACK_LOCATION_SCREEN: 'Press Back - Location Screen',
  PRESS_BACK_STARTBY_SCREEN: 'Press Back - Startby Screen',
  PRESS_BACK_DESCRIPTION_SCREEN: 'Press Back - Description Screen',
  PRESS_BACK_CONTACT_SCREEN: 'Press Back - Contact Screen',
  PRESS_SKIP: 'Press Skip -',
  PRESS_CLOSE: 'Press Close -',
  SELECT_CATEGORY: 'Select Category',
  SELECT_LOCATION: 'Select Location',
  UPSELL_APP_OVERLAY: 'Upsell App Overlay',
  UPSELL_JOB_SUCCESS_PAGE: 'Upsell Job - Job Success Page',
  POST_JOB: 'Post a job',
  REDEEMED_VOUCHER: 'Redeemed Vouchers',
  BLUR_SUGGEST_AUTOCOMPLETE: 'Blur Suggest Autocompelete',
  BLUR_LOCATION_AUTOCOMPLETE: 'Blur Location Autocompelete',
  FOCUS_SUGGEST_AUTOCOMPLETE: 'Focus Suggest Autocompelete',
  FOCUS_LOCATION_AUTOCOMPLETE: 'Focus Location Autocompelete',
  PRESS_SUBMIT_SEARCH: 'Clicked Submit Search',
  TO_SIGN_UP_WITH_EMAIL: 'To sign up with email',
  CLICKED_REGISTER_NOW_BUTTON: 'Clicked Register now button',
  CLICKED_JOBS_FEED_CATEGORY_LINK: 'Clicked Jobs Feed Category Link',
  CLICKED_FEEDBACKS_FEED_BUSINESS_LINK: 'Clicked Feedbacks Feed Business Link',
  LIST_YOUR_BUSINESS_FORM_FIELD_COMPLETED: 'completed',
  LIST_YOUR_BUSINESS_FORM_FIELD_SKIPPED: 'skipped',
  CLICKED_REGISTER_NOW_ANCHOR_LINK: 'clicked register now anchor link',
  CLICKED_TRADIE_TESTIMONIAL_LINK: 'clicked tradie testimonial link',

  // Articles

  PINTEREST_CLICK_SAVE_BUTTON: 'Pinterest - Click Save Button',
  BREADCRUMB_CLICK_LINK: 'Breadcrumb - Click Link',
  TOPIC_LABEL_CLICK_PRIMARY_TOPIC_LINK: 'Topic Label - Click Primary Topic Link',
  TOPIC_LABEL_CLICK_SECONDARY_TOPIC_LINK: 'Topic Label - Click Secondary Topic Link',
  GET_QUOTES_WIDGET_CLICK_BUTTON: 'Get Quotes Widget - Click Button',
  RATE_CITY_WIDGET_CLICK_BUTTON: 'Rate City Widget - Click Button',
  GET_QUOTES_WIDGET_SUBMIT_FORM: 'Get Quotes Widget - Submit Form',
  GET_QUOTES_HERO_CLICK_BUTTON: 'Get Quotes Hero - Click Button',
  GET_QUOTES_TRADE_HERO_CLICK_BUTTON: 'Get Quotes Trade Hero - Click Button',
  GET_QUOTES_HERO_SUBMIT_FORM: 'Get Quotes Hero - Submit Form',
  SEARCHBAR_PERFORM_ARTICLE_SEARCH: 'Searchbar - Perform Article Search',
  PREVIOUS_ARTICLE_CLICK_LINK: 'Previous Article - Click Link',
  NEXT_ARTICLE_CLICK_LINK: 'Next Article - Click Link',
  LATEST_ARTICLES_CLICK_IMAGE: 'Latest Articles - Click Image',
  LATEST_ARTICLES_CLICK_LINK: 'Latest Articles - Click Link',
  SPONSOR_CLICK_IMAGE: 'Sponsor - Click Image',
  SOCIAL_SHARE_BAR_CLICK_ICONS: 'Social Share Bar - Click Icons',
  BACK_TO_TOP_CLICK_BUTTON: 'Back To Top - Click Button',
  INLINE_GET_QUOTES_WIDGET_CLICK_BUTTON: 'Inline Get Quotes Widget - Click Button',

  // Community
  VIEW_LOCAL_RECOMMENDATIONS: 'View Local Recommendations',

  // Bunnings
  GET_STARTED_HERO_CLICK_BUTTON: 'Get Started Hero - Click Button',
  GET_STARTED_FORM_CLICK_BUTTON_LOGGEDIN: 'Get Started Form - Click Button LoggedIn',
  GET_STARTED_FORM_CLICK_BUTTON_NOT_LOGGEDIN: 'Get Started Form - Click Button Not LoggedIn',
  GET_STARTED_FORM_CLICK_BUTTON_HIPAGES_TRADIE: 'Get Started Form - Click Button Hipages Tradie',
  GET_STARTED_FORM_CLICK_BUTTON_POWERPASS: 'Get Started Form - Click Button Powerpass',
  FORM_QUESTION_CLICK_BUTTON_YES: 'Form Question - Click Button Yes',
  FORM_QUESTION_CLICK_BUTTON_NO: 'Form Question - Click Button No',
  FORM_QUESTION_CLICK_BUTTON_NEXT: 'Form Question - Click Button Next',
  USED_FILTER: 'Used Filter',
  GET_QUOTES: 'Get Quotes',
  ACTIONED_ACTIVITY: 'Actioned Activity',

  //Credit Usage
  SELECT_ADD_CREDIT: 'Select Add Credit',
  SELECT_VIEW_CREDIT_BREAKDOWN: 'Select View Credit Breakdown',
  SELECT_VIEW_USAGE_HISTORY: 'Select View Usage History',
  SELECT_UPGRADE_MEMBERSHIP: 'Select Upgrade Membership',
  SELECT_FAQ: 'Select FAQ'
};

export const EventLabels = {
  PRESS_BUSINESS_CARD: 'Press Business Card',
  PRESS_BUSINESS_DETAILS: 'Press Business Details',
  PRESS_MESSAGE_BUTTON: 'Press Message Button',
  PRESS_HIRE_BUTTON: 'Press Hire Button',
  PRESS_MORE_BUTTON: 'Press More Button',
  PRESS_PHONE_ICON: 'Press Phone Icon',
  PRESS_MAKE_A_PAYMENT_BUTTON: 'Press Make a Payment Button',
  PRESS_REQUEST_RECEIPT_BUTTON: 'Press Request Receipt Button',
  PRESS_LEAVE_FEEDBACK_BUTTON: 'Press Leave Feedback Button',
  PRESS_VIEW_PROFILE: 'Press View Profile',
  PRESS_CONTACT_SUPPORT_BUTTON: 'Press Contact Support Button',
  CLICK_CLOSE_JOB: 'Click Close Job',
  CLICK_VIEW_DETAILS_BUTTON: 'Click View Details Button',
  CLICK_ACTIVATE_MY_VOUCHER_BUTTON: 'Click Activate my vouchers button',
  CLICK_ACTIVATE_VOUCHER_BUTTON_LOGGED_OUT: 'Logged out brand activate page - click activate',
  CLICK_ACTIVATE_VOUCHER_BUTTON_LOGGED_IN: 'Logged in brand activate page - click activate',
  PRESS_CONNECT_BUTTON: 'Press Connect Button',
  AFTER_JOBS_PAGE: 'After Jobs Page',
  SUCCESS_PAGE_NEW_USER: 'success page - new user',
  SUCCESS_PAGE_REPEAT_USER: 'success page - repeat user',
  FB_ERROR_NOTIFICATION_DISPLAYED: 'notification displayed - FB',
  CLICK_BUSINESS_THUMBNAIL: 'Click Business Thumbnail',
  CLICK_PHONE_NUMBER: 'Click Phone Number',
  FOCUS_TEXT_FEILD: 'Press Text Field',
  PRESS_SEND_BUTTON: 'Press Send Button',
  PRESS_RETRY_BUTTON: 'Press Retry Button',
  PRESS_DELETE_BUTTON: 'Press Delete Button',
  PRESS_PAY_FROM_CONVO: 'Press Pay Button from Conversation',
  PRESS_PAY_FROM_BANNER: 'Press Pay Now from Request Banner',
  PRESS_PAY_FROM_MESSAGE: 'Press Pay Now from Request Message',
  PRESS_RECEIPT_FROM_CONVO: 'Press Receipt Button from Conversation',
  PRESS_CANCEL_FROM_MESSAGE: 'Press Cancel Button from Request Message',
  PRESS_HIRE_FROM_CONVO: 'Press Hire Button from Conversation',
  PRESS_BACK_BUTTON: 'Press Back Button',
  PRESS_ATTACH_BUTTON: 'Press Attach Photo Button',
  CLICKED_GO_TO_JOBS: 'Click Go To My Jobs Button',
  CLICKED_GET_QUOTES_BUTTON: 'Click Get Quotes Button',
  CLICKED_CLAIM_NOW_BUTTON: 'Click Claim Now Button',
  COMPLETED_VERIFICATION: 'View Final Verification Step',
  CLICK_SET_PASSWORD_BUTTON: 'Click Set Password Button',
  CLICK_CONNECT_FACEBOOK_BUTTON: 'Click Connect with Facebook Button',
  CLICK_ALREADY_REGISTERED_BUTTON: 'Click Already registered Button',
  CLICK_ALREADY_REGISTERED_WITH_HIPAGES_BUTTON: 'Click Already registered with hipages Button',
  CLICK_NEW_TO_HIPAGES_BUTTON: 'Click New to hipages Button',
  CLICK_NEW_TO_HIPAGES_SIGN_UP_BUTTON: 'Click New to hipages? Sign up Button',
  CONNECT_FACEBOOK_SUCCESS: 'View Connect Facebook Success Screen',
  PASSWORD_SET_SUCCESS: 'View Password Set Success Screen',
  BACK_TO_JOBS: 'Back to Jobs',
  CLICK_SET_PASSWORD_ERROR: 'Password Save Error - click Please try again',
  CLICK_SIGN_UP_WITH_EMAIL: 'Click sign up with email Button',
  CLICKED_SIGN_UP: 'Click sign up Button',
  VIEW_APP_UPSELL: 'View App Upsell',
  PRESS_GET_APP_BUTTON: 'Press Get The App Button',
  PRESS_NO_THANKS_BUTTON: 'Press No Thanks Button',
  PRESS_CLOSE_BUTTON: 'Press Close Button',
  VIEW_NEXT_JOB_UPSELL: 'View Next Job Upsell',
  PRESS_DISMISS_BUTTON: 'Press Dismiss Button',
  CLICK_GET_QUOTE: 'Click Get Quote',
  VIEW_DETAIL: 'Click View Job Details button',
  CLICK_ADD_VOUCHER_BUTTON_ON_MY_OFFER: 'Click Add Voucher Button On My Offer',
  ADVERTISE_PAGE: 'advertise page',

  // Articles

  PINTEREST_CLICK_SAVE_BUTTON: 'Pinterest - Click Save Button',
  GET_QUOTES_HERO_CLICK_BUTTON: 'Get Quotes Hero - Click Button',
  GET_QUOTES_TRADE_HERO_CLICK_BUTTON: 'Get Quotes Trade Hero - Click Button',
  GET_QUOTES_WIDGET_CLICK_BUTTON: 'Get Quotes Widget - Click Button',
  RATE_CITY_WIDGET_CLICK_BUTTON: 'Rate City Widget - Click Button',

  // Community

  SHOW_LOCAL_RECOMMENDATIONS_CARD: 'Show Local Recommendations Card',
  PRESS_LOCAL_RECOMMENDATIONS_CARD: 'Press View Local Recommendations Button',

  // Bunnings
  GET_STARTED_HERO_CLICK_BUTTON: 'Get Started Hero - Click Button',
  GET_STARTED_FORM_CLICK_BUTTON_LOGGEDIN: 'Get Started Form - Click Button LoggedIn',
  GET_STARTED_FORM_CLICK_BUTTON_NOT_LOGGEDIN: 'Get Started Form - Click Button Not LoggedIn',
  GET_STARTED_FORM_CLICK_BUTTON_HIPAGES_TRADIE: 'Get Started Form - Click Button Hipages Tradie',
  GET_STARTED_FORM_CLICK_BUTTON_POWERPASS: 'Get Started Form - Click Button Powerpass',
  // EXTERNAL
  PRESS_QUOTE_ACTION_BUTTON_SUCCESS_PAGE: 'Press Post a job Button - Success page'
};
